import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { useAuth } from '../auth/useAuth.js';

const tiles = [
  { to: '/picks', title: 'Make picks', text: 'Set your winners for the current week and lock in a tiebreaker.' },
  { to: '/leaderboard/weekly', title: 'Weekly leaderboard', text: 'See who is winning this week once the games start.' },
  { to: '/leaderboard/season', title: 'Season standings', text: 'Ranked by weeks won across the season.' },
  { to: '/schedule', title: 'Schedule', text: 'Browse the full season, week by week.' },
];

export function Home() {
  const { user } = useAuth();

  return (
    <div>
      <h1 className="h2">Welcome back, {user?.firstName || 'player'}.</h1>
      <p className="lead text-muted">Weekly NFL pick&apos;em.</p>

      <Row className="g-3 mt-1">
        {tiles.map((tile) => (
          <Col key={tile.to} md={6} lg={3}>
            <Card className="h-100">
              <CardBody>
                <h2 className="h6">
                  <Link to={tile.to} className="stretched-link text-decoration-none">{tile.title}</Link>
                </h2>
                <p className="text-muted small mb-0">{tile.text}</p>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="mt-4 p-3 border rounded bg-body-tertiary">
        <h2 className="h6">How scoring works</h2>
        <ul className="small text-muted mb-0">
          <li>One point for every game you pick correctly. A tied game counts for nobody.</li>
          <li>Picking opens two days before the first kickoff of the week.</li>
          <li>The Thursday game locks at its own kickoff; everything else locks when the second game starts.</li>
          <li>Nobody can see anyone else&apos;s picks until the first game of the week begins.</li>
          <li>Tied on correct picks? Closest guess to the last game&apos;s combined score wins the week.</li>
          <li>Still tied? Everyone still level is credited with the week.</li>
        </ul>
      </div>
    </div>
  );
}
